module.exports = __webpack_public_path__ + "static/img/redeem.a55d8bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh-CN/redeem.png
// module id = 5w8M
// module chunks = 1